module.exports = global["BVFetch"] = require("-!/builds/bv-com/web/frontend/node_modules/babel-loader/lib/index.js??ref--10-0!./fetch.js");